import { DateTime } from 'luxon';

/**
 * If the start and endTime fall on the same day, and are equal, it is an all-day event
 * If the start and endTime are apart by at least 23 hours, it is an all-day event
 */
export const checkIsAllDayEvent = ({
    startDateTime,
    endDateTime,
}: {
    startDateTime: string;
    endDateTime: string;
}): boolean => {
    if (!startDateTime || !endDateTime) {
        return false;
    }
    const start = DateTime.fromISO(startDateTime);
    const end = DateTime.fromISO(endDateTime);

    return start.toMillis() === end.toMillis() || end.diff(start, 'hours').hours >= 23;
};
